<div class="container-fluid">
  <app-pagetitle title="Board Reads" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

  <div class="main-card-container">
    <div class="card">
      <div class="card-body">
        <!-- Header Section -->
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h4 class="card-title mb-0">Board Reading</h4>

          <div class="d-flex align-items-center gap-2">
            <div class="dropdown" ngbDropdown>
              <button class="btn btn-light" ngbDropdownToggle>
                <i class="mdi mdi-dots-vertical"></i>
              </button>
              <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                <a href="javascript:void(0);" class="dropdown-item" (click)="downloadCsv()">
                  <i class="mdi mdi-download me-2"></i>Export Board Read
                </a>
              </div>
            </div>
            <button class="btn btn-light" (click)="refresh()" ngbTooltip="Refresh">
              <i class="mdi mdi-refresh"></i>
            </button>
          </div>
        </div>

        <!-- Search Box -->
        <div class="search-box mb-4">
          <div class="position-relative">
            <input type="text"
                   class="form-control"
                   placeholder="Search board reads..."
                   [(ngModel)]="term"
                   (ngModelChange)="onSearchDebounced($event)">
            <i class="mdi mdi-magnify search-icon"></i>
          </div>
        </div>

        <!-- Table Section -->
        <div class="table-responsive">
          <div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-2 gap-2">
            <div class="text-muted small">
              Showing last {{monthsLoaded}} months of board reads (newest first). Load more if you need older history.
            </div>
            <div class="d-flex align-items-center gap-2">
              <button class="btn btn-outline-primary btn-sm"
                      (click)="loadMoreMonths()"
                      [disabled]="isLoading">
                <ng-container *ngIf="!isLoading; else loadingMore">
                  Load previous {{defaultMonths}} months
                </ng-container>
                <ng-template #loadingMore>Loading…</ng-template>
              </button>
              <span *ngIf="isLoading" class="spinner-border spinner-border-sm text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </span>
            </div>
          </div>
          <div>
            <button style="font-weight: 700;font-size: 1.3em;" (click)="decrementPage()" *ngIf="canDecrement()">&lt;</button>
            &nbsp; page {{pageNumber + 1}} of {{numberOfPages}} &nbsp;
            <button style="font-weight: 700;font-size: 1.3em;" (click)="incrementPage()" *ngIf="canIncrement()">&gt;</button>
          </div>
          <table class="table table-hover">
            <thead>
              <tr>
                <th class="sticky-col">Asset Tag</th>
                <th>Time Stamp</th>
                <th>Serial Number</th>
                <th>Sales Rep</th>
                <th>Game Name</th>
                <th class="text-end">Cash In</th>
                <th class="text-end">Cash Out</th>
                <th class="text-end">Net Revenue</th>
                <th class="text-end">Turnover</th>
                <th class="text-end">Credit Won</th>
                <th class="text-end">Games Played</th>
                <th class="text-end">Games Won</th>
                <th class="text-end">Payout %</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let item of filteredPagenatedReads; trackBy: trackByRead">
                <tr>
                 <td class="sticky-col">
                        <div class="d-flex flex-column align-items-start">
                          <a href="javascript:void(0);" (click)="openBoardStatsModal(item.board?.assetTag)">
                            {{ item.board?.assetTag }}
                          </a>

                          <button
                           *ngIf="loginService.userType === 'ROOT'"
                            class="btn btn-sm btn-outline-success px-2 py-0 mt-1"
                            style="font-size: 0.75rem; line-height: 1.2;"
                            (click)="createStatsForBoardRead(item)"
                            ngbTooltip="Create or Update Stats"
                          >
                            Create Stats
                          </button>
                        <button
                          *ngIf="loginService.userType === 'ROOT'"
                          class="btn btn-sm btn-outline-success px-2 py-0 mt-1"
                          style="font-size: 0.75rem; line-height: 1.2;"
                          (click)="openUpdateModal(item)"
                          ngbTooltip="Update Board Read"
                        >
                          Update Board Read
                        </button>

                        </div>
                </td>

                  <td>{{ item.timeStamp | date:'short' }}</td>
                  <td>{{ item.board?.serialNumber }}</td>
                  <td>
                      {{ item.board?.location?.salesRep.firstName }}
                      {{ item.board?.location?.salesRep.lastName }}
                  </td>
                  <td>
                      {{ item.board?.installedGamePackage?.name }}
                       <button class="btn btn-sm btn-link text-primary ms-2" (click)="openGameMetersModal(item)">
                      <i class="mdi mdi-eye-outline"></i> View Individual Game Board Reads
                    </button>
                </td>

                  <td class="text-end font-monospace">{{ item.cashIn | number:'1.0-0' }}</td>
                  <td class="text-end font-monospace">{{ item.cashOut | number:'1.0-0' }}</td>
                  <td class="text-end font-monospace" [ngClass]="{ 'text-success': item.cashIn - item.cashOut > 0, 'text-danger': item.cashIn - item.cashOut < 0 }">
                    {{ (item.cashIn - item.cashOut) | number:'1.0-0' }}
                  </td>
                  <td class="text-end font-monospace">{{ item.coinIn | number:'1.0-0' }}</td>
                  <td class="text-end font-monospace">{{ item.coinOut | number:'1.0-0' }}</td>
                  <td class="text-end font-monospace">{{ item.gamesPlayed | number:'1.0-0' }}</td>
                  <td class="text-end font-monospace">{{ item.gamesWon | number:'1.0-0' }}</td>
                  <td class="text-end font-monospace">
                    {{ item.cashIn > 0 ? ((item.cashOut / item.cashIn) * 100 | number:'1.0-1') : 'N/A' }}%
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>

          <!-- Empty State -->
          <div *ngIf="filteredReads?.length === 0" class="text-center py-5">
            <p class="text-muted mb-0">No board reads found</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ✅ MODAL MOVED OUTSIDE *ngFor -->
  <ng-template #gameMetersModal let-modal>
    <div class="modal-header">
      <h5 class="modal-title">Game Meters for {{ selectedBoardItem?.board?.assetTag }}</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>

    <div class="modal-body">
      <div *ngIf="loadingMeters[selectedBoardItem?.id]" class="text-center p-3">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <div *ngIf="!loadingMeters[selectedBoardItem?.id] && boardGameMeters[selectedBoardItem?.id]?.length > 0" class="table-responsive">
        <table class="table table-sm table-bordered mb-0">
          <thead class="table-light">
            <tr>
              <th>Game</th>
              <th>Coin In</th>
              <th>Coin Out</th>
              <th>Net</th>
              <th>Games Played</th>
              <th>Games Won</th>
              <th>Win Ratio</th>
              <th>RPT</th>
              <th>Avg Bet</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let meter of boardGameMeters[selectedBoardItem?.id]; trackBy: trackByMeter">
              <td>{{ meter.game?.gameName }}</td>
              <td>{{ meter.coinIn | number:'1.0-0' }}</td>
              <td>{{ meter.coinOut | number:'1.0-0' }}</td>
              <td>{{ (meter.coinIn - meter.coinOut) | number:'1.0-0' }}</td>
              <td>{{ meter.gamesPlayed }}</td>
              <td>{{ meter.gamesWon }}</td>
              <td>{{ (meter.gamesPlayed ? (meter.gamesWon / meter.gamesPlayed * 100) : 0) | number:'1.0-0' }}%</td>
              <td>{{ (meter.coinIn ? (meter.coinOut / meter.coinIn * 100) : 0) | number:'1.0-1' }}%</td>
              <td>{{ (meter.gamesPlayed ? (meter.coinIn / meter.gamesPlayed) : 0) | number:'1.1-1' }}</td>
            </tr>
          </tbody>
          <tfoot class="table-light">
            <tr>
              <th>Total</th>
              <th>{{ boardGameMeters[selectedBoardItem?.id] | sum:'coinIn' | number:'1.0-0' }}</th>
              <th>{{ boardGameMeters[selectedBoardItem?.id] | sum:'coinOut' | number:'1.0-0' }}</th>
              <th>{{ (boardGameMeters[selectedBoardItem?.id] | sum:'coinIn') - (boardGameMeters[selectedBoardItem?.id] | sum:'coinOut') | number:'1.0-0' }}</th>
              <th>{{ boardGameMeters[selectedBoardItem?.id] | sum:'gamesPlayed' }}</th>
              <th>{{ boardGameMeters[selectedBoardItem?.id] | sum:'gamesWon' }}</th>
              <th>
                {{
                  (
                    (boardGameMeters[selectedBoardItem?.id] | sum:'gamesPlayed') > 0
                      ? (boardGameMeters[selectedBoardItem?.id] | sum:'gamesWon') /
                        (boardGameMeters[selectedBoardItem?.id] | sum:'gamesPlayed') * 100
                      : 0
                  ) | number:'1.0-0'
                }}%
              </th>
              <th>
                {{
                  (
                    (boardGameMeters[selectedBoardItem?.id] | sum:'coinIn') > 0
                      ? (boardGameMeters[selectedBoardItem?.id] | sum:'coinOut') /
                        (boardGameMeters[selectedBoardItem?.id] | sum:'coinIn') * 100
                      : 0
                  ) | number:'1.0-1'
                }}%
              </th>
              <th>
                {{
                  (
                    (boardGameMeters[selectedBoardItem?.id] | sum:'gamesPlayed') > 0
                      ? (boardGameMeters[selectedBoardItem?.id] | sum:'coinIn') /
                        (boardGameMeters[selectedBoardItem?.id] | sum:'gamesPlayed')
                      : 0
                  ) | number:'1.1-1'
                }}
              </th>
            </tr>
          </tfoot>
        </table>
      </div>

      <div *ngIf="!loadingMeters[selectedBoardItem?.id] && (!boardGameMeters[selectedBoardItem?.id] || boardGameMeters[selectedBoardItem?.id].length === 0)" class="text-muted p-2">
        No game meters available for this board read.
      </div>
    </div>
  </ng-template>
  <ng-template #updateBoardReadModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Update Board Read</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body">
    <div class="mb-3">
      <label for="locationSelect" class="form-label">Location</label>
      <select class="form-select" [(ngModel)]="selectedLocationId" id="locationSelect">
        <option [value]="null">-- Select Location --</option>
        <option *ngFor="let loc of allLocations; trackBy: trackByLocation" [value]="loc.id">
          {{ loc.locationTag }} - {{ loc.locationName }}
        </option>
      </select>
    </div>

    <div class="mb-3">
      <label for="gamePackageSelect" class="form-label">Game Package</label>
      <select class="form-select" [(ngModel)]="selectedGamePackageId" id="gamePackageSelect">
        <option [value]="null">-- Select Game Package --</option>
        <option *ngFor="let game of allGamePackages; trackBy: trackByGame" [value]="game.id">
          {{ game.name }} ({{ game.version }})
        </option>
      </select>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="updateBoardReadSelection(); modal.close()">Update</button>
  </div>
</ng-template>

</div>
